import utils from '@/utils'
const { loadable } = utils;

const Index = loadable(() => import(/* webpackChunkName: 'index' */ '@/views/Index'))


// 其它
const UploadView = loadable(() => import(/* webpackChunkName: 'upload' */ '@/views/Others/Upload'))

const TestView = loadable(() => import(/* webpackChunkName: 'TestView' */ '@/views/TestView'))


const Admin = loadable(() => import(/* webpackChunkName: 'user' */ '@/views/Admin'))
const AdminCreate = loadable(() => import(/* webpackChunkName: 'userEdit' */ '@/views/Admin/AdminCreate'))
const AdminEdit = loadable(() => import(/* webpackChunkName: 'userEdit' */ '@/views/Admin/AdminEdit'))
const AdminChangePassword = loadable(() => import(/* webpackChunkName: 'userEdit' */ '@/views/Admin/AdminChangePassword'))

const Role = loadable(() => import(/* webpackChunkName: 'Label' */ '@/views/Role'))
const RoleEdit = loadable(() => import(/* webpackChunkName: 'Setting' */ '@/views/Role/RoleEdit'))

const User = loadable(() => import(/* webpackChunkName: 'user' */ '@/views/User'))
const UserEdit = loadable(() => import(/* webpackChunkName: 'userEdit' */ '@/views/User/UserEdit'))

const QuickTask = loadable(() => import(/* webpackChunkName: 'QuickTask' */ '@/views/QuickTask'))
const QuickTaskEdit = loadable(() => import(/* webpackChunkName: 'QuickTaskEdit' */ '@/views/QuickTask/QuickTaskEdit'))

const Task = loadable(() => import(/* webpackChunkName: 'Task' */ '@/views/Task'))
const TaskEdit = loadable(() => import(/* webpackChunkName: 'TaskEdit' */ '@/views/Task/TaskEdit'))

const Order = loadable(() => import(/* webpackChunkName: 'Task' */ '@/views/Order'))
const OrderEdit = loadable(() => import(/* webpackChunkName: 'TaskEdit' */ '@/views/Order/OrderEdit'))

const PaymentLog = loadable(() => import(/* webpackChunkName: 'Task' */ '@/views/PaymentLog'))

const VipCard = loadable(() => import(/* webpackChunkName: 'Task' */ '@/views/VipCard'))
const VipCardEdit = loadable(() => import(/* webpackChunkName: 'TaskEdit' */ '@/views/VipCard/VipCardEdit'))

const PointCard = loadable(() => import(/* webpackChunkName: 'Task' */ '@/views/PointCard'))
const PointCardEdit = loadable(() => import(/* webpackChunkName: 'TaskEdit' */ '@/views/PointCard/PointCardEdit'))

const Setting = loadable(() => import(/* webpackChunkName: 'Setting' */ '@/views/Setting'))
const SettingEdit = loadable(() => import(/* webpackChunkName: 'Setting' */ '@/views/Setting/SettingEdit'))

const MemberLevelConfig = loadable(() => import(/* webpackChunkName: 'MemberLevelConfig' */ '@/views/MemberLevelConfig'))
const MemberLevelConfigEdit = loadable(() => import(/* webpackChunkName: 'Setting' */ '@/views/MemberLevelConfig/MemberLevelConfigEdit'))

const Label = loadable(() => import(/* webpackChunkName: 'Label' */ '@/views/Label'))
const LabelEdit = loadable(() => import(/* webpackChunkName: 'Setting' */ '@/views/Label/LabelEdit'))

const ModelCategory = loadable(() => import(/* webpackChunkName: 'Label' */ '@/views/ModelCategory'))
const ModelCategoryEdit = loadable(() => import(/* webpackChunkName: 'Setting' */ '@/views/ModelCategory/ModelCategoryEdit'))

const ModelName = loadable(() => import(/* webpackChunkName: 'Label' */ '@/views/ModelName'))
const ModelNameEdit = loadable(() => import(/* webpackChunkName: 'Setting' */ '@/views/ModelName/ModelNameEdit'))

const ModelPicture = loadable(() => import(/* webpackChunkName: 'Label' */ '@/views/ModelPicture'))
const ModelPictureEdit = loadable(() => import(/* webpackChunkName: 'Setting' */ '@/views/ModelPicture/ModelPictureEdit'))

const Apikeys = loadable(() => import(/* webpackChunkName: 'Apikeys' */ '@/views/Apikeys'))
const ApikeysEdit = loadable(() => import(/* webpackChunkName: 'Setting' */ '@/views/Apikeys/ApikeysEdit'))

const SocialPicture = loadable(() => import(/* webpackChunkName: 'SocialPicture' */ '@/views/SocialPicture'))
const SocialReview = loadable(() => import(/* webpackChunkName: 'SocialReview' */ '@/views/SocialReview'))
const SocialEdit = loadable(() => import(/* webpackChunkName: 'SocialEdit' */ '@/views/SocialReview/SocialEdit'))
const SocialType = loadable(() => import(/* webpackChunkName: 'SocialType' */ '@/views/SocialType'))
const SocialTypeEdit = loadable(() => import(/* webpackChunkName: 'SocialTypeEdit' */ '@/views/SocialType/SocialTypeEdit'))
const SocialTag = loadable(() => import(/* webpackChunkName: 'SocialTag' */ '@/views/SocialTag'))
const SocialTagEdit = loadable(() => import(/* webpackChunkName: 'SocialTagEdit' */ '@/views/SocialTag/SocialTagEdit'))

const routes = [
    { path: '/index', exact: true, name: 'Index', component: Index, auth: ['admin', 'superAdmin'] },

    // { path: '/others/upload', exact: false, name: '上传', component: UploadView, auth: ['admin', 'superAdmin'] },
    // { path: '/one/two/three', exact: false, name: '三级', component: Three },

    { path: '/admin', exact: false, name: '管理员', component: Admin, auth: ['admin', 'superAdmin'] },
    { path: '/admin/adminCreate', exact: false, name: '管理员新增', component: AdminCreate, auth: ['admin', 'superAdmin'] },
    { path: '/admin/adminEdit', exact: false, name: '管理员编辑', component: AdminEdit, auth: ['admin', 'superAdmin'] },
    { path: '/admin/changePassword', exact: false, name: '修改密码', component: AdminChangePassword, auth: ['admin', 'superAdmin'] },

    { path: '/role', exact: false, name: '用户', component: Role, auth: ['admin', 'superAdmin'] },
    { path: '/role/edit', exact: false, name: '用户', component: RoleEdit, auth: ['admin', 'superAdmin'] },

    { path: '/user', exact: false, name: '用户', component: User, auth: ['admin', 'superAdmin'] },
    { path: '/user/userEdit', exact: false, name: '用户', component: UserEdit, auth: ['admin', 'superAdmin'] },

    { path: '/quickTask', exact: false, name: '快捷任务', component: QuickTask, auth: ['admin', 'superAdmin'] },
    { path: '/quickTask/quickTaskEdit', exact: false, name: '快捷任务', component: QuickTaskEdit, auth: ['admin', 'superAdmin'] },

    { path: '/task', exact: false, name: '任务', component: Task, auth: ['admin', 'superAdmin'] },
    { path: '/task/taskEdit', exact: false, name: '任务', component: TaskEdit, auth: ['admin', 'superAdmin'] },

    { path: '/order', exact: false, name: '订单', component: Order, auth: ['admin', 'superAdmin'] },
    { path: '/order/orderEdit', exact: false, name: '订单', component: OrderEdit, auth: ['admin', 'superAdmin'] },

    { path: '/VipCard', exact: false, name: '积分卡', component: VipCard, auth: ['admin', 'superAdmin'] },
    { path: '/VipCard/edit', exact: false, name: '积分卡', component: VipCardEdit, auth: ['admin', 'superAdmin'] },

    { path: '/pointCard', exact: false, name: '积分卡', component: PointCard, auth: ['admin', 'superAdmin'] },
    { path: '/pointCard/edit', exact: false, name: '积分卡', component: PointCardEdit, auth: ['admin', 'superAdmin'] },

    { path: '/PaymentLog', exact: false, name: '支付记录', component: PaymentLog, auth: ['admin', 'superAdmin'] },

    { path: '/setting', exact: false, name: '设置', component: Setting, auth: ['admin', 'superAdmin'] },
    { path: '/setting/edit', exact: false, name: '设置', component: SettingEdit, auth: ['admin', 'superAdmin'] },

    { path: '/MemberLevelConfig', exact: false, name: '用户等级', component: MemberLevelConfig, auth: ['admin', 'superAdmin'] },
    { path: '/MemberLevelConfig/edit', exact: false, name: '用户等级', component: MemberLevelConfigEdit, auth: ['admin', 'superAdmin'] },

    { path: '/label', exact: false, name: '分类', component: Label, auth: ['admin', 'superAdmin'] },
    { path: '/label/edit', exact: false, name: '分类', component: LabelEdit, auth: ['admin', 'superAdmin'] },

    { path: '/modelCategory', exact: false, name: '模特类型', component: ModelCategory, auth: ['admin', 'superAdmin'] },
    { path: '/modelCategory/edit', exact: false, name: '模特类型', component: ModelCategoryEdit, auth: ['admin', 'superAdmin'] },

    { path: '/modelName', exact: false, name: '模特名字', component: ModelName, auth: ['admin', 'superAdmin'] },
    { path: '/modelName/edit', exact: false, name: '模特名字', component: ModelNameEdit, auth: ['admin', 'superAdmin'] },

    { path: '/modelPicture', exact: false, name: '模特图片', component: ModelPicture, auth: ['admin', 'superAdmin'] },
    { path: '/modelPicture/edit', exact: false, name: '模特图片', component: ModelPictureEdit, auth: ['admin', 'superAdmin'] },

    { path: '/apikeys', exact: false, name: '模特图片', component: Apikeys, auth: ['admin', 'superAdmin'] },
    { path: '/apikeys/edit', exact: false, name: '模特图片', component: ApikeysEdit, auth: ['admin', 'superAdmin'] },

    { path: '/test', exact: false, name: '测试', component: TestView, auth: ['admin', 'superAdmin'] },

    { path: '/SocialPicture', exact: false, name: '服装圈图片', component: SocialPicture, auth: ['admin', 'superAdmin'] },
    { path: '/socialReview', exact: false, name: '服装圈审核', component: SocialReview, auth: ['admin', 'superAdmin'] },
    { path: '/social/edit', exact: false, name: '服装圈新增', component: SocialEdit, auth: ['admin', 'superAdmin'] },
    { path: '/socialType', exact: false, name: '服装圈大类', component: SocialType, auth: ['admin', 'superAdmin'] },
    { path: '/socialType/edit', exact: false, name: '服装圈大类', component: SocialTypeEdit, auth: ['admin', 'superAdmin'] },
    { path: '/socialTag', exact: false, name: '服装圈Tag', component: SocialTag, auth: ['admin', 'superAdmin'] },
    { path: '/socialTag/edit', exact: false, name: '服装圈Tag', component: SocialTagEdit, auth: ['admin', 'superAdmin'] },
]

export default routes
